import { render, staticRenderFns } from "./purchasesCard.vue.html?vue&type=template&id=37dc8345&"
import script from "./purchasesCard.ts?vue&type=script&lang=ts&"
export * from "./purchasesCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports